
export class ProjectItem {
    // Id: string;
    UserId: string;
    ProjectName: string;
    ProjectId: string;
    CICount: Map<string, number> ;//{ [type: string]: number };// Map<string, number>;
    TotalCICount: number;
    UrgentCICount: number;
    NewCICount:number;
    AllPendingCICount:number;
    PendingByProductionCICount:number;
    PendingMoreInfoCICount:number;
    PendingReleaseNeededCICount:number;
    AdPubCICount:number;
    ArtCICount:number;
    PropsCICount:number;
    SetDecCICount:number;
    WardrobeCICount:number;
    PostCICount:number;
    MarketingCICount:number;
    EndCreditCICount:number;
    StatusChangeCICount:number;
    ScriptCICount:number;
    LocationCICount:number;
    ResearchCICount:number;
    ClipCICount: number;
    MaterialReleaseCICount: number;
    ArtistCertificateCICount: number;
    PhotoReleaseCICount: number;
    ProductPlacementCICount: number;
    MainCharacterCICount: number;
    SecondaryCharacterCICount: number;
    IncidentalCharacterCICount: number;
    EffectsCICount: number;
    CrowdCICount: number;
    MouthChartCICount: number;
    SpecialPoseCICount: number;
    SizeCompCICount: number;
    CLRCount: number;
    DigimatteCount: number;
    GraphicCount: number;
    ApprovalPendingCICount: number;
    ApprovedCICount: number;
    DeferredCICount: number;
    DeniedCICount: number;
    SortOrder: number;
    PreferenceType: string;
    ContactTitle: string;    
    ContactName: string;
    ContactEmail:string;
    ContactPhoneNumber:string;
    constructor(projectId: string='', name: string='') {
        this.ProjectId = projectId;
        this.ProjectName = name;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/projectItem.ts